export default {
  balance: {},
  event: null,
  ended: false,
  bonuses: [],
  bonusesCount: 0,
  availableBonuses: [],
}
